import { render, staticRenderFns } from "./AddTariffData.vue?vue&type=template&id=f30d9630"
import script from "./AddTariffData.vue?vue&type=script&lang=js"
export * from "./AddTariffData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports